import React from 'react';
import { connect } from 'react-redux';
import {
    ACTIONS, getAdminDelivery,
    addWorkspace, getListFromAddWorkspace
} from './../../../../actions/admin-delivery';
import Loading from '../../../../components/loading';

class AddWorkSpace extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listWorkSpace: [],
            showLoading: false,
            arrListSelected: [],
            messageBlankCustomers: '',
            titleInput: ''
        };
    }

    removeItemWorkspace = (id) => {
        const arr = [];
        this.state.arrListSelected.map((val) => {
            if (val.id !== id) {
                arr.push(val);
            }
            return true;
        });
        this.setState({ arrListSelected: arr });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_DATA_ADMIN_DELIVERY_SUCCESS) {
                const list = this.convertListSuggestion(nextProps.response.data);
                list.length = 10;
                this.setState({ listWorkSpace: list });
            }
            if (nextProps.status === ACTIONS.ADD_WS_GET_CUSTOMERS_SUCCESS) {
                const listCompany = this.convertTextData(nextProps.response ? nextProps.response.companies : [], 'companies');
                const listCompanyUser = this.convertTextData(nextProps.response ? nextProps.response.company_users : [], 'company_users');
                const group = this.convertTextData(nextProps.response ? nextProps.response.group : [], 'group');
                const users = this.convertTextData(nextProps.response ? nextProps.response.users : [], 'users');
                this.setState({
                    listCustomers: [...listCompany, ...listCompanyUser, ...group, ...users],
                    showLoading: false
                }, () => {
                    if (this.state.listCustomers.length === 0) {
                        this.setState({
                            messageBlankCustomers: 'Not match'
                        })
                    }
                });
            }
            if (nextProps.status === ACTIONS.ADD_ADMIN_DELIVERY_WORKSPACE_SUCCESS) {
                this.setState({ showLoading: false });
                if (!nextProps.response.error) {
                    this.props.doneAddWorkspace();
                }
            }
        }
    }

    convertListSuggestion = (list) => {
        if (list) {
            let arr = [];
            list.forEach(val => {
                const listMap = [...val.destinations_companies, ...val.destinations_groups, ...val.destinations_users].map(value => {
                    if (value.company) {
                        return {
                            id: value.company.id, title: value.company ? value.company.name : '',
                            type: 'companies', count: value.company ? value.company.users_count : 0
                        }
                    }
                    if (value.group) {
                        return {
                            id: value.group.id, title: value.group ? value.group.name : '',
                            type: 'group', count: value.group ? value.group.users_count : 0
                        }
                    }
                    if (value.user) {
                        return {
                            id: value.user.id, title: value.user ? value.user.name : '',
                            type: 'users', count: value.user ? (value.user.group ? value.user.group.users_count : 0) : 0
                        }
                    }
                });
                // listMap.forEach(k => {
                //     arr.push(k)
                // });
                arr = [...arr,...listMap];
            });
            return arr.sort((a, b) => b.count - a.count);
        }
    }

    convertTextData = (arr, text) => {
        if (arr) {
            if (text === 'companies') {
                return arr.map(key => {
                    return { id: key.id, title: key.name, type: text }
                });
            } else {
                return arr.map(key => {
                    const title = key.company ? key.company.name : "";
                    return { id: key.id, title: title + '-' + key.name, type: text }
                });
            }
        }
    }

    getListFromAddWorkspace = (event) => {
        if (event.key === "Enter" && event.target.value !== '') {
            this.setState({ showLoading: true, messageBlankCustomers: '' });
            this.props.getListFromAddWorkspace(event.target.value);
        }
    }

    handleClickWorkSpace = (ev) => {
        const valueItem = [{ id: ev.id, title: ev.title, type: ev.type }];
        const mapData = [...this.state.arrListSelected, ...valueItem];
        const data = this.checkUniqueItemArr(mapData);
        this.setState({ arrListSelected: data })
    }

    checkUniqueItemArr = (arr) => {
        return [...new Map(arr.map(item => [item.id, item])).values()];
    }

    removeMessageBlank = () => {
        this.setState({ messageBlankCustomers: '' });
    }

    getTitleWorkspace = (ev) => {
        this.setState({ titleInput: ev.target.value });
    }

    convertTypeArrData = (arr) => {
        if (arr) {
            let ret = arr.reduce((acc, item) => ((acc[item['type']] = [...(acc[item['type']] || []), item]), acc), {});
            ret.users = [...ret.company_users || [] , ...ret.users || []];
            return ret;
        }
    }

    convertIdArr = (arr) => {
        if (arr) {
            return arr.map(x => x.id);
        } return []
    }

    handleAddWorkspace = () => {
        this.setState({ showLoading: true });
        if (this.state.arrListSelected) {
            const data = this.convertTypeArrData(this.state.arrListSelected);
            const convert = {
                title: this.state.titleInput,
                memo: '',
                destinations_company_ids: this.convertIdArr(data.companies),
                destinations_group_ids: this.convertIdArr(data.group),
                destinations_users: this.convertIdArr(data.users)
            }
            this.props.addWorkspace(convert)
        }
    }

    closeModal = () => {
        this.setState({
            listCustomers: [],
        })
        this.props.hide();
    }

    render() {
        return (
            <div className="wrap-workspace" id="wrap-workspace">
                <div className="workspace" id="workspace">
                    <h4>ワークスペースを追加</h4>
                    <input type="text" placeholder="ワークスペース名" onChange={this.getTitleWorkspace} />
                    <div className="item-customer">
                        {this.state.arrListSelected ?
                            this.state.arrListSelected.map((val, i) => {
                                return (
                                    <div key={i} className="item">
                                        <span>{val.title}</span>
                                        <img onClick={() => this.removeItemWorkspace(val.id)} alt="delete"
                                            src="/img/navigation/cancel_24px.svg" />
                                    </div>
                                )
                            }) : null}
                    </div>
                    <input type="text" placeholder="納品予定の宛先" onKeyPress={this.getListFromAddWorkspace}
                        onChange={this.removeMessageBlank} />
                    {
                        this.state.messageBlankCustomers ?
                            <p className="message">{this.state.messageBlankCustomers}</p> : null
                    }
                    <div className="list-search-customer">
                        {this.state.listCustomers ? this.state.listCustomers.map((item, index) => {
                            return (
                                <div key={index.toString()} className="item" onClick={() => this.handleClickWorkSpace(item)}>
                                    {item.title}
                                </div>
                            )
                        }) : null}
                    </div>
                    <div className="item-workspace">
                        <div className="item">
                            {this.state.listWorkSpace ?
                                this.state.listWorkSpace.map((val, i) => <span
                                    onClick={() => this.handleClickWorkSpace(val)}
                                    key={i.toString()}>{val.title}</span>) : null}
                        </div>
                    </div>
                    <div>
                        <button onClick={this.closeModal}>キャンセル</button>
                        <button onClick={this.handleAddWorkspace}>追加</button>
                    </div>
                </div>

                {/* Loading */}
                <Loading show={this.state.showLoading} />
            </div>
        );
    }
}

const mapStateToProps = ({ adminDelivery }) => {
    return {
        response: adminDelivery.response,
        status: adminDelivery.status
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getListFromAddWorkspace: (keyword) => {
            dispatch(getListFromAddWorkspace(keyword))
        },
        getAdminDelivery: (keyword) => {
            dispatch(getAdminDelivery(keyword))
        },
        addWorkspace: (data) => {
            dispatch(addWorkspace(data));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(AddWorkSpace);

